/*
Usage Notes: 

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker 
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      externalPriceSelector='#price-inner-button .money'
      externalPriceSelectorWithCurrency='[data-product-price-list] .money'
      currency='USD'
      useVariantInputClickEvents='false'
      variantInputSelector=''
      hideOneTime
      >
    </skio-plan-picker>
    <input type="hidden" aria-hidden="true" name="selling_plan" value="">
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
    {% render 'skio-details' %}
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  * {
    box-sizing: border-box;
  } 
  
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    padding: 0;
    border: 0;
    margin: .4rem 0;

    --primary: var(--skio-primary, #2C1203);
    --secondary: var(--skio-secondary, #c65238);
    --accent: var(--skio-accent, #B1A7A2);
    --background: var(--skio-background, #f3f2ef);
    
    color: var(--primary);
    
  }
  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    border-color: var(--accent);
    transition: border-color 0.2s ease;
    background-color: var(--background);
    border-top: 1px solid var(--accent);
  }
  .skio-group-container--selected {
   
  }
  
  .skio-group-container--available:first-of-type {
    
  }
  .skio-group-container--available:last-of-type {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  
  .skio-group-container--available:first-of-type:not(.skio-group-container--selected) {
   
  }
  .skio-group-container--available:last-of-type:not(.skio-group-container--selected) {
   
  }
  
  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px var(--accent) solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 10px;
  }

  .sub-benefits {
  font-size: 1.2rem;
  font-weight: 400;
  margin-top: 0;
  }

  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    width: 100%;
    font-size: 14px;
    align-items: center;
  }
  
  .skio-radio__container {
    display: flex;
    margin-right: 8px;
    color: var(--secondary);
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
    .st2 {
    opacity: 0;
    }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(.9);
    opacity: 1;
  }
    .skio-group-label:hover .st2 {
    opacity: 1;
    }
    .skio-group-container--selected .skio-group-label .st2 {
    opacity: 1;
    }
  
  .skio-price {
    margin-left: auto;
    font-weight: 700;
    display: flex;
    align-items: flex-end;
    color: var(--primary);
  }
    @media (max-width: 1024px) {
 .skio-price {
align-items: flex-start;
}
}
.skio-price s {
color: var(--primary);
}

.skio-price .regular-price {
color: var(--primary);
}
  
  .skio-group-content {
    width: auto;
    margin-left: 26px;
    
    opacity: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .skio-group-content__inner {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: 0;
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
    display: none;
  }
  
  .skio-group-title {
    display: flex;
    flex-direction: row;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.4rem;
    flex-grow: 1;
  }
  
  // .skio-save {
  //   color: #0fa573;
  //   border: 1px #0fa573 solid; 
  //   padding: 0px 8px;
  //   border-radius: 20px;
  // }
  #frequency-tooltip {
  color: var(--primary);
  }
  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    margin-top: 5px;
    border-radius: 5px;
    background-color: #f7f7f7;
    width: 100%;
    border: 0;
    font-size: 14px;
    font-family: inherit;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
    pointer-events: none;
  }

  skio-plan-picker .link__strike {
  margin-right: 8px;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }
  
  .skio-group-container--selected .skio-group-topline {
    font-weight: 500;
  }
  
  .skio-frequency-container {
    display: inline-flex;
    overflow: hidden;
  }
    .skio-frequency-container select {
    background-color: var(--background);
border: none;
    border-bottom: 1px solid #DCDBC4;
    text-transform: lowercase;
  font-size: 1.2rem;
  font-family: var(--font-body-family);
  font-weight: 400;
  line-height: 1.8rem;
letter-spacing: .6px;
padding-right: 1rem;
color: var(--primary);
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.25 3.75H8.75L5 7.5L1.25 3.75Z' fill='%232A1103'/%3E%3C/svg%3E");
    background-repeat: no-repeat, repeat;
    background-position: right 0 top 50%, 0 0;
    background-size: .65em auto, 100%;
}
  
  .skio-frequency-radio {
    position: relative;
    cursor: pointer;
    font-size: 12px;
    display: inline-block;
    padding: 10px 13px;
    line-height: 1;
    color: #000;
    border-right: 1px solid #000;
    background-color: var(--background);
  }
  
  .skio-frequency-radio:last-of-type {
    border-right: 0;
  }
  
  .skio-frequency-radio input[type="radio"] {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  
  .skio-frequency-radio.skio-frequency-radio--selected {
    background-color: #fff;
    color: #000;
    font-weight: 500;
  }
  
  .skio-frequency-label {
    font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.4rem;
letter-spacing: 1.5px;
  }
  
  .skio-group-subtitle {
    font-size: 10px;
    display: block;
    margin-top: 2px;
    font-weight: 300;
  }
  
  span[skio-save-price] {
    color: var(--primary);
    font-size: 12px;
    font-weight: 300;
    display: none;
  }

  .after-discount {
    font-size: 12px;
    padding-left: 0;
    padding-right: 8px;
    display: inline-block;
    white-space: nowrap;
    line-height: 1.5;
  }
    .product-card-wrapper .after-discount {
padding-left: 0;
}
  
  .skio-group-container--selected span[skio-save-price] {
    display: none;
  }
  
  @media screen and (max-width: 1199px) {
    .skio-frequency-container {
      max-width: 190px;
    }
    
    .skio-frequency-radio {
      text-align: center;
      padding-left: 6px;
      padding-right: 6px;
      padding-top: 3px;
      padding-bottom: 3px;
      font-size: 10px;
      width: auto;
    }
  }
  @media screen and (max-width: 530px) {
    .after-discount {
    white-space: normal;
    padding: 0;
    }
}
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },            //required
    productHandle: { type: String },      //optional (unless product isn't passed, then required)
    key: { type: String },                //optional, defaults to product.id; identifier for this instance of the Skio plan picker

    formId: { type: String },             //optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean },       //optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form

    subscriptionFirst: { type: Boolean }, //optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, //optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String },     //optional, defaults to percent; can also pass "fixed"

    currency: { type: String },           //optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String },           //optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {},                   //placeholder for object

    externalPriceSelector: { type: String },      //optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String },      //optional, used to update the external price

    selectedVariant: { type: Object },    //placeholder for data
    skioSellingPlanGroups: {},            //placeholder for data
    availableSellingPlanGroups: {},       //placeholder for data
    selectedSellingPlanGroup: {},         //placeholder for data
    selectedSellingPlan: {},              //placeholder for data

    defaultFrequency: {},                 //placeholder for data

    useVariantInputClickEvents: { type: Boolean }, // optional, allows use of variant input click events to update skio's selectedVariant
    variantInputSelector: {},

    hideOneTime: { type: Boolean }, // optional, hides one time option
    hasProductGridContainer: { type: Boolean },
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.hasProductGridContainer = false;
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = 'onetime';

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.externalPriceSelector = '[skio-external-price]';

    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';

    this.currency = Shopify.currency.active;
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });

    this.defaultFrequency = null;

    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;
    this.hideOneTime = false;

    this.strikethroughDiscountMultiplier = 1; // Default to 1 (no discount)

  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription == true) {
      this.purchaseOption = 'subscription';
    }

    if (!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key')) {
            if (el.getAttribute('skio-key') == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }
    if (!window.updateSkioPrices) {
      window.updateSkioPrices = (discountPercentage) => {
        document.querySelectorAll('skio-plan-picker').forEach(component => {
          if (typeof component.updatePricesWithDiscount === 'function') {
            component.updatePricesWithDiscount(discountPercentage);
          }
        });
      };
    }
    
    let skio = this;
    document.addEventListener("variantChanged", function (e) {
      //update variant id
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find(x => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    if (this.formId) {
    const form = document.querySelector(`#${this.formId}`);
    const checkedRadio = form?.querySelector('[name="id"]:checked');
    if (checkedRadio) {
      let deepLinkedVariantId = parseInt(checkedRadio.value, 10);
      let variantObj = this.product?.variants?.find(v => v.id === deepLinkedVariantId);
      if (variantObj) {
        this.selectedVariant = variantObj;
      }
    }
  }

    if (this.useVariantInputClickEvents) {
      document.addEventListener('load', skio.addVariantClickEventListeners);
    }

    // console.log("this.closest('.drtv__hideOneTime')", this.closest('.drtv__hideOneTime'));
    if (this.closest('.drtv__hideOneTime')) {
      this.hideOneTime = true;
    }
    // Initialize prices on collection pages
    if (this.hasProductGridContainer && this.hideOneTime) {
      this.initializeCollectionPrices();
      
    }

  }

  render() {
    if (!this.product || !this.selectedVariant || this.skioSellingPlanGroups.length == 0) return;

    // Check if the component is inside the card wrapper
    const isProductCard = this.closest('.product-card-wrapper');

    // Function to format the price
    function formatPrice(price) {
      // Format the price to two decimal places
      let formattedPrice = (price / 100).toFixed(2);

      // Remove trailing zeros
      formattedPrice = parseFloat(formattedPrice).toString();

      return formattedPrice;
    }

    return html`
      <style>
       .skio-group-topline {
        display: ${this.hasProductGridContainer ? 'none !important' : 'flex'};
      }
        .skio-group-container--available { 
        border-top:  ${this.hasProductGridContainer ? 'none !important' : '1px solid #B1A7A2'};
        }
        .skio-group-label {
padding: ${this.hasProductGridContainer ? '0 !important' : '10px'};
  }
       
.skio-group-content {
margin-left: ${this.hasProductGridContainer ? '0 !important' : '30px'};
  }
        .skio-group-content__inner {
        margin: ${this.hasProductGridContainer ? '0 auto' : ''};
margin-top: ${this.hasProductGridContainer ? '0 !important' : '1.3rem;'};
        }

        .skio-group-title {
         flex-wrap: ${isProductCard ? 'wrap' : 'nowrap'};
       }
         .skio-group-title .after-discount {
padding-left: ${isProductCard ? '0' : '8px'};
  }
    </style>
      <fieldset class="skio-plan-picker" skio-plan-picker="${this.key}">
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="selling_plan" type="hidden" value="${this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ''}" />
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="properties[Discount]" type="hidden" value="${this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : ''}" 
          ?disabled="${this.selectedSellingPlan == null ? true : false}" />
          
          ${this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) =>
      html`
            <div class="skio-group-container skio-group-container--available ${this.selectedSellingPlanGroup == group ? 'skio-group-container--selected' : ''}" skio-group-container
              @click=${() => this.selectSellingPlanGroup(group)}>
              <input id="skio-selling-plan-group-${index}-${this.key}" class="skio-group-input" name="skio-group-${this.key}"
                type="radio" value="${group.id}" skio-selling-plan-group="${group.id}" ?checked=${this.selectedSellingPlanGroup == group ? true : false} >
              <label class="skio-group-label" for="skio-selling-plan-group-${index}-${this.key}">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="16" height="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
                      <style type="text/css">
	                      .st0{fill:none;stroke:var(--primary);}
	                      .st1{fill:#dcdbc4;}
	                      .st2{fill-rule:evenodd;clip-rule:evenodd;fill:var(--primary);}
                      </style>
                        <circle class="st0" cx="8" cy="8" r="7.5"/>
                        <circle class="st1 skio-radio" cx="8" cy="8" r="8"/>
                        <path class="st2" d="M4,9.3l0.5-0.9l3.3,2.2L11.2,4L12,4.5L8.2,12C8.2,12,4,9.3,4,9.3z"/>
                    </svg>
                  </div>
                  <div class="skio-group-title">
                    <div>
                      ${window.discountPercentage
                        ? (group.name === 'Subscription'
                          ? html`
                              <span class="skio-save">Subscribe & Save</span>
                            `
                          : ''
                        )
                        : (this.discount(group.selected_selling_plan).percent !== '0%'
                          ? html`
                              <span class="skio-save">Subscribe & Save <span skio-discount>${this.discountFormat == 'percent' ? this.discount(group.selected_selling_plan).percent : this.discount(group.selected_selling_plan).amount}</span></span>
                            `
                          : (group.name === 'Subscription'
                              ? html`
                                  <span class="skio-save">Subscribe & Save</span>
                                `
                              : ''
                            )
                          )
                      }
                    </div>
                   
                    
                    <div class="skio-price">
                    ${this.selectedVariant.compare_at_price && this.selectedVariant.compare_at_price > this.selectedVariant.price ? html`
      <!-- Use compare_at_price as strikethrough price -->
      <span class="regular-price" style="font-weight: 300; color: var(--primary);">
        <s>$${formatPrice(this.selectedVariant.compare_at_price)}</s>
      </span>
      <span skio-subscription-price>&nbsp;${this.price(group.selected_selling_plan)}</span>
    ` : html`
      <!-- Use price as strikethrough price -->
      <span class="regular-price" style="font-weight: 300; color: var(--primary);">
        <s>$${formatPrice(this.selectedVariant.price)}</s>
      </span>
      <span skio-subscription-price>&nbsp;${this.price(group.selected_selling_plan)}</span>
    `
        }
                    <span skio-save-price>Save ${this.money(this.discount(group.selected_selling_plan).amount)}</span>
                  </div>
                  </div>
                  
                </div>
                <div class="skio-group-content">
                  
                  <span class="after-discount">Cancel anytime</span>
                  <div class="skio-group-content__inner">
                  
                  ${this.selectedSellingPlan ? html`
                      <span class="skio-frequency-label">Ships every </span> 
                    ` : ''
        }
  <div class="skio-frequency-container" skio-selling-plans="${group.id}">
    <select name="frequency" 
                  @change=${(e) => {
                    this.selectSellingPlan(e.target, group);
                    if (this.hasProductGridContainer) {
                      this.updateCollectionFrequency(e.target, group);
                    }
                  }}>
                  ${group ? group.selling_plans.map((selling_plan) =>
                    html`
                      <option value="${selling_plan.id}" ?selected=${group.selected_selling_plan == selling_plan}>
                        ${selling_plan.name.replace('Every', '')}
                      </option>
                    `
                  ) : ''}
                </select>
  </div>
  <slot name="frequency-tooltip"></slot>
</div>

                  ${!this.hasProductGridContainer
          ? html`
        <h2 class="sub-benefits" style="margin-bottom: 0;">
          SUBSCRIPTION BENEFITS
        </h2>
        <slot name="subscription-benefits">
          <ul>
            <li>15% off every subscription order</li>
            <li>Free gift on your first two subscription orders</li>
            <li>3x True Beauties Rewards points on every order</li>
            <li>Skip or cancel any time</li>
          </ul>
        </slot>
      `
          : null
        }
                </div>
              </label>
            </div>
          `
    ) : ''}
        
        ${!this.hideOneTime ? html`
            <div class="skio-group-container ${!this.product.requires_selling_plan ? 'skio-group-container--available' : ''} ${this.selectedSellingPlanGroup == null ? 'skio-group-container--selected' : ''} ${this.subscriptionFirst ? 'skio-onetime-second' : ''}" skio-group-container 
              @click=${() => this.selectSellingPlanGroup(null)} >
            
              <input id="skio-one-time-${this.key}" class="skio-group-input" name="skio-group-${this.key}" type="radio" value="" 
                skio-one-time ?checked=${this.startSubscription == false && !this.product.requires_selling_plan}>
              <label class="skio-group-label" for="skio-one-time-${this.key}">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                  <svg width="16" height="16" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
                                     <style type="text/css">
                                       .st0{fill:none;stroke:var(--primary);}
                                       .st1{fill:#dcdbc4;}
                                       .st2{fill-rule:evenodd;clip-rule:evenodd;fill:var(--primary);}
                                     </style>
                                       <circle class="st0" cx="8" cy="8" r="7.5"/>
                                       <circle class="st1 skio-radio" cx="8" cy="8" r="8"/>
                                       <path class="st2" d="M4,9.3l0.5-0.9l3.3,2.2L11.2,4L12,4.5L8.2,12C8.2,12,4,9.3,4,9.3z"/>
                                   </svg>
                  </div>
                  <div class="skio-group-title">
                    <span>
                      One Time Purchase
                    </span>
                    <div class="skio-price">
                    ${(() => {
                      // If this component is excluded, always show the simple, non-discounted price.
          const isExcluded = this.hasAttribute('data-exclude-strikethrough');
          if (salePricing && !isExcluded) {
                        const finalSalePriceInCents = this.selectedVariant.price * this.strikethroughDiscountMultiplier;
                        return html`
                          <span skio-onetime-price>
                            <span class="regular-price" style="font-weight: 300;"><s>$${formatPrice(this.selectedVariant.price)}</s></span>&#32;
                            <span class="sale-price salePricing">${this.money(finalSalePriceInCents)}</span>
                          </span>
                        `;
                      }
            
          const strikeElement = document.querySelector('.product__price .strike');
          if (bundleDiscount && !salePricing && !isExcluded) {
            const compareAtPrice = strikeElement.textContent.trim();
            const currentPrice = document.getElementById('product-price').textContent.trim();
            return html`
                            <span skio-onetime-price>
                              <span class="regular-price" style="font-weight: 300;"><s>${compareAtPrice}</s></span>&#32;
                              <span class="sale-price">${currentPrice}</span>
                            </span>
                          `;
          }
          else if (strikeElement && !salePricing && !isExcluded) {
            return html`
                            <span skio-onetime-price>
                              <span class="regular-price" style="font-weight: 300;"><s>$${formatPrice(this.selectedVariant.compare_at_price)}</s></span>&#32;
                              <span class="sale-price strikePricing">${this.money(this.selectedVariant.price)}</span>
                            </span>
                          `;
          } else if (salePricing && !isExcluded) {
            const finalSalePriceInCents = this.selectedVariant.price * this.strikethroughDiscountMultiplier;
          return html`
                  <span skio-onetime-price>
                    <span class="regular-price" style="font-weight: 300;"><s>$${formatPrice(this.selectedVariant.price)}</s></span>&#32;
                    <span class="sale-price salePricing">${this.money(finalSalePriceInCents)}</span>
                  </span>
                `;
            } else {
            return html`
                            <span skio-onetime-price>
                              <span class="regular-price">${this.money(this.selectedVariant.price)}</span>
                            </span>
                          `;
          }
        })()
        }
                    </div>
                  </div>
                </div>
              </label>
            </div>
          ` : null
      }
      </fieldset>`
  }

  // New method to initialize collection prices
  initializeCollectionPrices() {
    // Find the quick-add button associated with this product
    const quickAddButtons = document.querySelectorAll('.quick-add__submit.gtm-add-to-cart');
    quickAddButtons.forEach(button => {
      // Check if this button belongs to the current product
      if (button.getAttribute('data-product-id') == this.product.id) {
        this.updateQuickAddButtonPrice(button);
      }
    });
  }

  // Add new method to handle collection frequency updates
  updateCollectionFrequency(selectElement, group) {
    const selling_plan = group.selling_plans.find(x => x.id == selectElement.value);
    if (!selling_plan) {
      this.log("Error: couldn't find selling plan for collection update");
      return;
    }
    // Find the quick-add button for this specific product
    const quickAddButtons = document.querySelectorAll('.quick-add__submit.gtm-add-to-cart');
    quickAddButtons.forEach(button => {
      if (button.getAttribute('data-product-id') == this.product.id) {
        // Calculate prices
        const originalPrice = this.selectedVariant.compare_at_price || this.selectedVariant.price;
        const formattedOriginalPrice = (originalPrice / 100).toFixed(2);
        const subscriptionPrice = this.price(selling_plan);

        // Update button text with new prices
        button.innerHTML = `Subscribe -&nbsp;<span class="regular-price"><s>$${formattedOriginalPrice}</s></span>&nbsp;<span class="sale-price">${subscriptionPrice}</span>`;
      }
    });
  }

  // New method to update quick-add button prices
  updateQuickAddButtonPrice(button) {
    if (!button) return;

    function formatPrice(price) {
      let formattedPrice = (price / 100).toFixed(2);
      formattedPrice = parseFloat(formattedPrice).toString();
      return formattedPrice;
    }

    // For collection pages, we always show the subscription price since hideOneTime is true
    if (this.selectedSellingPlan) {
      const originalPrice = this.selectedVariant.compare_at_price || this.selectedVariant.price;
      const formattedOriginalPrice = formatPrice(originalPrice);
      const subscriptionPrice = this.price(this.selectedSellingPlan);

      button.innerHTML = `Subscribe -&nbsp;<span class="regular-price"><s>$${formattedOriginalPrice}</s></span>&nbsp;<span class="sale-price">${subscriptionPrice}</span>`;
    }
  }

  updatePricesWithDiscount(discountPercentage) {
    if (isNaN(discountPercentage)) return;
    this.strikethroughDiscountMultiplier = 1 - (discountPercentage / 100);
    this.requestUpdate();
  }

  updated = (changed) => {
    if (changed.has('product') && this.product) {

      //update key
      this.key = this.key ? this.key : this.product.id;

      //update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort(function (a, b) {
          if (parseInt(a.name.replace(/\D/g, "")) < parseInt(b.name.replace(/\D/g, ""))) return -1;
          if (parseInt(a.name.replace(/\D/g, "")) > parseInt(b.name.replace(/\D/g, ""))) return 1;
          if (parseInt(a.name.replace(/\D/g, "")) == parseInt(b.name.replace(/\D/g, ""))) return 0;
        })
      });
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        //update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach((group => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.purchaseOption == 'subscription') {
          //find a matching selling plan, or choose first available
          if (this.selectedSellingPlan == null || this.selectedSellingPlan == undefined) {
            let sellingPlanGroup = this.availableSellingPlanGroups.find(spg => this.selectedVariant.selling_plan_allocations.some(spa => spa.selling_plan_group_id === spg.id));
            this.selectSellingPlanGroup(sellingPlanGroup);
          }

          let sellingPlanName = this.selectedSellingPlan.name;

          let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.selling_plans.find(y => y.name == sellingPlanName));
          let sellingPlan = sellingPlanGroup.selling_plans.find(y => y.name == sellingPlanName);
          if (sellingPlanName == sellingPlan.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup;
            this.selectedSellingPlan = sellingPlan;
          } else {
            this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
            this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
          }

        } else {
          // Clear selection if not a subscription context
          this.selectedSellingPlan = null;
          this.selectedSellingPlanGroup = null;
        }

      } else {
        // This variant has no subscription options.
        // 1. Clear any existing subscription selection.
        this.selectedSellingPlan = null;
        this.selectedSellingPlanGroup = null;
        
        // 2. Force the component's internal state to select 'onetime'.
        this.purchaseOption = 'onetime';
      }

      //update the form that was passed, if any
      this.updateForm();

    
      
    }

  

    if (changed.has('selectedVariant') || changed.has('selectedSellingPlan')) {
      this.updateHiddenInput();
      
      // Toggle .installment class based on selection
      this._updateInstallmentVisibility();

      if (!this.hasProductGridContainer) {
        // update price of price elements if applicable 
        console.log(this.selectedSellingPlan);
        console.log('skio change');
        document.querySelectorAll(`[skio-price][skio-key="${this.key}"]`).forEach((el) => {
          el.innerHTML = this.price(this.selectedSellingPlan);
        });
      
        /**
         * Defines the logic for updating the innerHTML of an add-to-cart button
         * based on the selected selling plan and pricing rules.
         * @param {HTMLElement} button - The button element to update.
         */
        const updateAddToCartButton = (button) => {
          if (!button) {
            return; // Exit if the button doesn't exist
          }

          const isExcluded = this.hasAttribute('data-exclude-strikethrough');
          
          const frequencyWrapper = button.closest('.drtv__HeroFrequencyWrapper');
          const buttonText = this.selectedSellingPlan != null && frequencyWrapper ? 'Get Offer' : 'Add to Bag - ';
      
          function formatPrice(price) {
            // Format the price to two decimal places
            let formattedPrice = (price / 100).toFixed(2);
            // Remove trailing zeros for whole numbers
            formattedPrice = parseFloat(formattedPrice).toString();
            return formattedPrice;
          }
      
          // --- Subscription selected ---
          if (this.selectedSellingPlan) {
            const originalPrice = this.selectedVariant.compare_at_price || this.selectedVariant.price;
            const formattedOriginalPrice = formatPrice(originalPrice);
      
            // Check if a global tiered/sale discount is active
            if (salePricing && typeof strikethroughDiscountMultiplier !== 'undefined') {
              const finalSalePriceInCents = originalPrice * this.strikethroughDiscountMultiplier;
              const formattedFinalSalePrice = this.money(finalSalePriceInCents);
              button.innerHTML = `${buttonText} <span class="regular-price">&nbsp;<s>$${formattedOriginalPrice}</s></span><span class="sale-price"><span>&nbsp;</span>${formattedFinalSalePrice}</span>`;
            } else {
              const subscriptionPrice = this.price(this.selectedSellingPlan);
              button.innerHTML = `${buttonText} <span class="regular-price">&nbsp;<s>$${formattedOriginalPrice}</s></span><span class="sale-price"><span>&nbsp;</span>${subscriptionPrice}</span>`;
            }
      
          // --- One-time purchase selected ---
          } else {
            if (salePricing && !isExcluded) {
              const finalSalePriceInCents = this.selectedVariant.price * this.strikethroughDiscountMultiplier;
              const formattedFinalSalePrice = this.money(finalSalePriceInCents);
              button.innerHTML = `${buttonText} <span skio-onetime-price>&nbsp;<span class="regular-price"><s>$${formatPrice(this.selectedVariant.price)}</s></span>&#32;<span class="sale-price">${formattedFinalSalePrice}</span></span>`;
            } else {
              const strikeElement = document.querySelector('.product__price .strike');
              if (bundleDiscount && !isExcluded) {
                const compareAtPrice = strikeElement.textContent.trim();
                const currentPrice = document.getElementById('product-price').textContent.trim();
                button.innerHTML = `${buttonText} <span skio-onetime-price>&thinsp;<span class="regular-price"><s>${compareAtPrice}</s></span>&#32;<span class="sale-price">${currentPrice}</span></span>`;
              } else if (strikeElement && !isExcluded) {
                button.innerHTML = `${buttonText} <span skio-onetime-price><span class="regular-price"><s>$${formatPrice(this.selectedVariant.compare_at_price)}</s></span>&#32;<span class="sale-price">$${formatPrice(this.selectedVariant.price)}</span></span>`;
              } else {
                button.innerHTML = `${buttonText} $${formatPrice(this.selectedVariant.price)}`;
              }
            }
          }
        };
      
        // Select both the main and sticky buttons and apply the update logic to each.
        document.querySelectorAll('#AddToCart, #AddToCart-sticky').forEach(updateAddToCartButton);
      
        // update text and price of the button with class "js-drtvNav-addtocart"
        const drtvNavAddToCartButton = document.querySelector('.js-drtvNav-addtocart');
        if (drtvNavAddToCartButton) {
          const buttonText = this.selectedSellingPlan != null ? 'Get Offer' : 'Add to Bag';
          drtvNavAddToCartButton.querySelector('.js-add-to-cart-text').innerHTML = `${buttonText} - ${this.price(this.selectedSellingPlan)}`;
        }
      
        // update display of external content elements
        document.querySelectorAll(`[skio-onetime-content][skio-key="${this.key}"]`).forEach((el) => {
          this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
        });
      
        document.querySelectorAll(`[skio-subscription-content][skio-key="${this.key}"]`).forEach((el) => {
          this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
        });
      
        // dispatch CustomEvent to tell that this specific plan picker was updated, and pass the selectedSellingPlan
        const event = new CustomEvent(`skio::update-selling-plan`, {
          bubbles: true,
          composed: true,
          detail: {
            sellingPlan: this.selectedSellingPlan,
            key: this.key
          }
        });
      
        this.dispatchEvent(event);
      
        // update the form that was passed, if any
        this.updateForm();
        this.updateExternalPrice();
      
        // update external selling_plan input value
        let sellingPlanInput = document.querySelector('input[name="selling_plan"]');
        this.selectedSellingPlan != null ? sellingPlanInput.value = this.selectedSellingPlan.id : sellingPlanInput.value = '';
      } else {
        // Update prices for collection page
        const quickAddButtons = document.querySelectorAll('.quick-add__submit.gtm-add-to-cart');
        quickAddButtons.forEach(button => {
          if (button.getAttribute('data-product-id') == this.product.id) {
            this.updateQuickAddButtonPrice(button);
          }
        });
      }
    }

    if (changed.has('formId')) {
      //update the form that was passed, if any
      this.updateForm();
    }

  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) => {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  _updateInstallmentVisibility() {
    const installmentElements = document.querySelectorAll('.installment');
    if (!installmentElements.length) return; // Do nothing if no elements are found

    if (this.selectedSellingPlan) {
      // Subscription is active
      installmentElements.forEach(el => el.classList.add('hidden'));
    } else {
      // One-time is active
      installmentElements.forEach(el => el.classList.remove('hidden'));
    }
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    })
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency;
    })

  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (group) this.purchaseOption = 'subscription'
    else this.purchaseOption = 'onetime'

    // Update hidden input
    this.updateHiddenInput();

    //update the form that was passed, if any
    this.updateForm();

    // Toggle .installment class based on selection
    this._updateInstallmentVisibility();
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;

      // Always update the hidden input value
      this.updateHiddenInput();

      // If this is a collection page product, update the quick-add button
      if (this.hasProductGridContainer) {
        this.updateQuickAddButtonPrice(
          document.querySelector(`.quick-add__submit.gtm-add-to-cart[data-product-id="${this.product.id}"]`)
        );
      }
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  // Add new method to specifically handle hidden input updates
  updateHiddenInput() {
    if (this.formId) {
      const form = document.querySelector(`#${this.formId}`);
      if (!form) return;
    
      const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) {
        if (this.selectedSellingPlan) {
          sellingPlanInput.value = this.selectedSellingPlan.id;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }
    }
    
  }

  // Formats integer value into money value

// Formats integer value into money value
money(price) {
  // Return a default or empty value if the price is invalid
  if (price === null || typeof price === 'undefined') {
    return '';
  }

  // Use Intl.NumberFormat just to reliably get the currency symbol
  const parts = this.moneyFormatter.formatToParts(0);
  const currencySymbol = parts.find(part => part.type === 'currency')?.value || '$';

  // Format the price to a string with exactly two decimal places
  let finalPriceString = (price / 100.0).toFixed(2);

  // Check ONLY if the formatted string ends with '.00'
  if (finalPriceString.endsWith('.00')) {
    // If it does, remove the trailing '.00'
    finalPriceString = finalPriceString.slice(0, -3);
  }
  
  // For all other cases (e.g., ends in .50, .55), the string remains unchanged.
  return `${currencySymbol}${finalPriceString}`;
}

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }

    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const originalPrice = this.selectedVariant.compare_at_price || this.selectedVariant.price;

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (originalPrice * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / originalPrice) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((originalPrice - price_adjustment.value) * 1.0) /
            originalPrice) *
          100.0
        )}%`
        discount.amount = originalPrice - price_adjustment.value
        break
    }

    return discount
  }

  price(selling_plan, formatted = true) {
    // Start with the base price (either compare_at_price for sales or the regular price)
    let price = this.selectedVariant.compare_at_price || this.selectedVariant.price;
    
    // 1. First, apply the built-in subscription discount from the selling plan itself
    price -= this.discount(selling_plan).amount;

    // Check for the exclusion attribute.
    const isExcluded = this.hasAttribute('data-exclude-strikethrough');

    // 2. Then, apply the external tiered discount multiplier, but ONLY if the component is NOT excluded.
    if (!isExcluded && this.strikethroughDiscountMultiplier < 1) {
      price *= this.strikethroughDiscountMultiplier;
    }

    // 3. Return the final calculated price, formatted as money
    return formatted ? this.money(price) : price;
  }


  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement('input');
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector('[name="properties[Discount]"]');
        if (discount_input) {
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          discount_input = document.createElement('input');
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(discount_input);
        }
      } else {
        console.log(`Skio error: form ID is ${this.formId}, but no form with that ID was found.`);
      }
    }
  }

  updatePricesWithDiscount(discountPercentage) {
    if (isNaN(discountPercentage)) return;
    this.strikethroughDiscountMultiplier = 1 - (discountPercentage / 100);
    this.requestUpdate(); // triggers reactive update/render
  }

  addVariantClickEventListeners() {
    let variantInputs = document.querySelectorAll(this.variantInputSelector)
    let skio = this
    for (let el of variantInputs) {
      el.addEventListener('click', function (e) {
        // may need to replace with ID / e.target depending on client setup
        // may need to use different attribute depending on ^^
        let variantTitle = e.currentTarget.value
        skio.selectedVariant = skio.product.variants.find(variant => variant.title == variantTitle)
      })
    }
  }

  // Optional functions keep if necessary 

  /**
   *   
   * 
   */

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart(quantity) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity: quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then((response) => response.json())
      .then((response) => {
        this.log("SKIO added item to cart: ", response);
        //dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent(`skio::added-to-cart`, {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key
          }
        });

        this.dispatchEvent(event);
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error);
      });
      console.log(this.selectedVariant.id);
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[1];

        return product;
      });
  }
}




customElements.define('skio-plan-picker', SkioPlanPickerComponent);